import React from 'react';
import { Link } from 'react-router-dom';
import { Database } from 'lucide-react';
import { motion } from 'framer-motion';

const CallToAction = () => {
  return (
    <motion.section 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="text-center py-12"
    >
      <h2 className="text-2xl font-bold mb-4 text-content-primary">
        Explore Our Database
      </h2>
      <p className="text-content-secondary mb-8 max-w-2xl mx-auto">
        Discover detailed information about animatronic figures from theme parks 
        and attractions worldwide. From classic figures to cutting-edge creations, 
        our comprehensive database has it all.
      </p>
      <Link
        to="/database"
        className="inline-flex items-center px-6 py-3 bg-brand hover:bg-brand-dark text-white rounded-lg transition-colors"
      >
        <Database className="w-5 h-5 mr-2" />
        Browse the Database
      </Link>
    </motion.section>
  );
};

export default CallToAction;